<template>
  <div v-if="show" class="transition-overlay">
    <div class="transition-overlay__content">
      <slot>{{ message }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransitionOverlay',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: '금융 서비스를 제공하는 펀다에이아이로 이동합니다'
    },
    delay: {
      type: Number,
      default: 1000
    },
    to: {
      type: [String, Object],
      required: true
    }
  },
  watch: {
    async show(newVal) {
      if (newVal) {
        await new Promise(resolve => setTimeout(resolve, this.delay))
        await this.$router.push(this.to)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.transition-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  &__content {
    color: white;
    font-size: 22px;
    font-weight: 500;
    text-align: center;
    padding: 20px;
    line-height: 1.5;
  }
}
</style> 